import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import { Panel } from 'primereact/panel';
import { intlShape } from '../../../components/prop-types';
import ImportDropzone from '../../../components/FileImportDropzone';

const messages = defineMessages({
  import: { id: 'res_import.file_field_label', defaultMessage: 'Import Respondents' },
});

/**
 * Render import form  for survey project
 * @param {Object} props
 */
const UploadForm = (props) => {
  const {
    onUpload,
    intl: { formatMessage },
  } = props;
  return (
    <Panel header={formatMessage(messages.import)}>
      <div className="p-grid">
        <div className="p-col-12">
          <ImportDropzone onUpload={onUpload} />
        </div>
        <div className="p-col-12">
          <a target="_blank" href="/import-templates/import-respondents.xlsx">
            <FormattedMessage id="res_import.download_hint" defaultMessage="Download Import Template file" />
          </a>
        </div>
      </div>
    </Panel>
  );
};

UploadForm.propTypes = {
  intl: intlShape.isRequired,
  onUpload: PropTypes.func.isRequired,
};

export default injectIntl(UploadForm);
